import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import '@/icons' // icon
import '@/permission' // permission control

//公共样式
import 'normalize.css/normalize.css' // A modern alternative to CSS resets
import '@/styles/index.scss' // global css
import '@/styles/variables.scss';

// element-ui组件库
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/element-ui.scss' //elementui 重置样式
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
Vue.use(ElementUI, { locale })


//请求
import axios from 'axios'
Vue.prototype.$axios = axios
import Http from '@/utils/request.js'
Vue.prototype.$http = Http
import Util from '@/utils/util.js'
Vue.prototype.$util = Util

//实时传输数据
import socket from './api/socket.js'
Vue.prototype.socket = socket;

//缓存
import { localData, sessionData } from "./utils/local.js"
Vue.prototype.$localData = localData;
Vue.prototype.$sessionData = sessionData;

// 通用数据
import jtUtils from "./utils/jtUtils.js"
Vue.prototype.$jtUtils = jtUtils

//全局指令
import directives from './directives.js'
Vue.use(directives)
import preventClick from './preventClick.js'
Vue.use(preventClick)

// 适配flex
import '@/common/flexible.js';
Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js